import React, { ReactElement } from "react"
import { LanguageCode } from "../../../CustomerInfo/types"

// TODO: Handle imports properly
// @ts-ignore
import GB from "./en-GB.svg"
// @ts-ignore
import US from "./en-US.svg"
// @ts-ignore
import CA from "./fr-CA.svg"
// @ts-ignore
import DE from "./de-DE.svg"
// @ts-ignore
import NL from "./nl-NL.svg"

export const flags: Record<LanguageCode, ReactElement> = {
	"en-GB": <img alt="en-GB" src={GB} width={18} height={12} />,
	"en-US": <img alt="en-US" src={US} width={18} height={12} />,
	"fr-CA": <img alt="fr-CA" src={CA} width={18} height={12} />,
	"de-DE": <img alt="de-DE" src={DE} width={18} height={12} />,
	"nl-NL": <img alt="nl-NL" src={NL} width={18} height={12} />,
}
